import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { NTA_COLORS } from '../constants';
import { ntaPageCss } from '../typography';

const CHEVRON_SRC = '/nta-experience/palette-collapse-chevron.svg';

const Track = styled.div`
  width: 24px;
  align-self: stretch;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  ${ntaPageCss}
`;

const Toggle = styled.button`
  width: 24px;
  height: 48px;
  padding: 8px;
  box-sizing: border-box;
  border: none;
  background: ${NTA_COLORS.paletteCollapseBg};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  ${ntaPageCss}

  &:focus-visible {
    outline: 2px solid ${NTA_COLORS.accentBlue};
    outline-offset: 2px;
  }
`;

const ChevronIcon = styled.img`
  width: 24px;
  height: 24px;
  display: block;
  object-fit: contain;
  transform: ${({ $collapsed }) => ($collapsed ? 'rotate(180deg)' : 'none')};
`;

const NtaPaletteCollapse = ({ collapsed, onToggle }) => (
  <Track>
    <Toggle
      type="button"
      onClick={onToggle}
      aria-expanded={!collapsed}
      aria-label={
        collapsed ? 'Expand question palette' : 'Collapse question palette'
      }
      title={collapsed ? 'Show question palette' : 'Hide question palette'}
    >
      <ChevronIcon
        src={CHEVRON_SRC}
        width={24}
        height={24}
        alt=""
        $collapsed={collapsed}
        aria-hidden
      />
    </Toggle>
  </Track>
);

export default NtaPaletteCollapse;

NtaPaletteCollapse.propTypes = {
  collapsed: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired
};
